// @ts-nocheck
import React from "react";
import { useNavigate } from "react-router-dom";
import "../styles/InfoPage.css";

export default function InfoPageLayout({ title, subtitle, updated, children }) {
  const navigate = useNavigate();

  return (
    <div className="info-screen">
      <div className="info-container">
        <button className="info-back" onClick={() => navigate(-1)}>
          ← Back
        </button>

        <h1 className="info-title">{title}</h1>
        {subtitle && <p className="info-subtitle">{subtitle}</p>}

        {children}

        {updated && (
          <div className="info-footer">
            <p>Last updated: {updated}</p>
          </div>
        )}
      </div>
    </div>
  );
}

// Reusable section component
export function InfoSection({ title, children }) {
  return (
    <section className="info-section">
      {title && <h2>{title}</h2>}
      {children}
    </section>
  );
}

// Reusable list component
export function InfoList({ items, children }) {
  if (items) {
    return (
      <ul className="info-list">
        {items.map((item, index) => (
          <li key={index}>{item}</li>
        ))}
      </ul>
    );
  }
  return <ul className="info-list">{children}</ul>;
}
